<template>
  <a-config-provider
    :locale="i18n.global.messages[i18n.global.locale]"
    prefix-cls="portal-ant"
  >
    <to-b v-if="isTOB"> </to-b>
    <main class="z10 pf l0 t0 w100vw h100vh" v-else>
      <router-view />
    </main>
    <!-- 全局 体验弹框 -->
    <FormModal ref="formModalRef"></FormModal>
    <!-- 旧创意平台引导弹窗 -->
    <a-modal
      v-model:open="showCreativePlatformModal"
      title="提示"
      :maskClosable="false"
      @cancel="closeCreativePlatformModal"
    >
      <p>
        请打开新的创意平台进行相关AI相关功能的使用：
        <a :href="creativePlatformUrl" target="_blank">前往新创意平台</a>
      </p>
      <template #footer>
        <a-button @click="closeCreativePlatformModal">关闭</a-button>
        <a-button type="primary" @click="openCreativePlatform"
          >打开新平台</a-button
        >
      </template>
    </a-modal>
    <!-- 限制浏览器弹框提醒 -->
    <a-modal
      :footer="null"
      v-model:open="isWarning"
      title="提示"
      :closable="false"
      :maskClosable="false"
      :bodyStyle="{
        padding: '16px 24px'
      }"
    >
      <p>
        <ExclamationCircleOutlined
          style="color: #faad14"
        ></ExclamationCircleOutlined>
        检测到您的浏览器非谷歌浏览器，为了提高您的使用体验，请下载谷歌浏览器
      </p>
      <a-row type="flex" class="mt20" justify="center">
        <a
          href="https://www.google.cn/intl/zh-CN/chrome/"
          target="_blank"
          class="mr40"
        >
          <img src="~/assets/img/chrome.png" alt="" srcset="" />
        </a>
        <!-- <a href="http://www.firefox.com.cn/" target="_blank">
          <img
            src="~/assets/img/firefox.png"
            style="width:32px;height:32px;"
            alt=""
            srcset=""
          />
        </a> -->
      </a-row>
      <div style="text-align: right;">
        <a-button v-if="closable" type="primary" @click="closeModal"
          >关闭</a-button
        >
        <a-button disabled v-else>{{ second }}s后可关闭弹窗</a-button>
      </div>
    </a-modal>
  </a-config-provider>
  <noticeModal
    v-if="showNoticeModal"
    :open="showNoticeModal"
    :noticeDetailInfo="noticeDetail"
    @close="showNoticeModal = false"
    @openDetail="showDetail = true"
  />
  <noticeDetail
    v-if="showDetail"
    :showDetail="showDetail"
    :id="noticeIds[0]"
    @close="closeNoticeDetail"
    title=""
  />
</template>

<script>
import {
  computed,
  onMounted,
  provide,
  ref,
  onUnmounted,
  nextTick,
  watch
} from 'vue'
// 获取路由对象
import { useRouter, useRoute } from 'vue-router'
// 获取axios中的对象
import toBLayout from './layout/toB.vue'
import { useStore } from 'vuex'
import { iframeListener } from 'cupshe-utils'
// import { isGoogleChrome, isFF, isSafri } from './utils/index.js'
import { detectBrowser } from './utils/index.js'
import { onLocalStorageChange, PORTAL_ROUTER_TAG_LIST } from './utils/utils.js'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import FormModal from './components/ui/FormModal.vue'
import moment from 'moment'
import noticeModal from '@/views/NoticePublishCenter/components/noticeModal.vue'
import { announcementCenter } from '@/apis/18726'
import { message } from 'ant-design-vue'
import noticeDetail from '@/views/NoticePublishCenter/components/noticeDetail.vue'
require('./utils/iframeHepler')
export default {
  name: 'App',
  components: {
    toB: toBLayout,
    ExclamationCircleOutlined,
    FormModal,
    noticeModal,
    noticeDetail
  },
  setup() {
    const LEGACY_CREATIVE_PLATFORM_URL = 'https://imagesearch.kapeixi.cn/'
    const NEW_CREATIVE_PLATFORM_URL =
      'https://creative-media.kapeixi.cn/image-recog/image-search'
    const showOperationPermissionModal = ref(false)
    const store = useStore()
    const formModalRef = ref()
    window.store = store
    const router = useRouter()
    window.router = router
    const route = useRoute()
    // 获取不同页面的布局
    const isTOB = computed(() => {
      if (['Login', '404'].includes(route.name)) {
        return false
      }
      return true
    })
    /** 计算导出任务数量和消息数量 */
    const useCount = ref({
      count: 0,
      msgCount: 0
    })
    const clear = () => {
      store.commit(
        'app/SET_RESETSTATE',
        {},
        {
          root: true
        }
      )
      store.commit(
        'user/SET_RESETSTATE',
        {},
        {
          root: true
        }
      )
      sessionStorage.clear()
      localStorage.clear()
    }

    provide('useCount', useCount.value)

    const showCreativePlatformModal = ref(false)
    const creativePlatformUrl = NEW_CREATIVE_PLATFORM_URL
    const lastPromptRoute = ref('')

    const normalizeTargetUrl = url => {
      if (!url || typeof url !== 'string') {
        return ''
      }
      try {
        const { origin, pathname } = new URL(decodeURIComponent(url))
        const normalizedPathname = pathname.endsWith('/')
          ? pathname
          : `${pathname}/`
        return `${origin}${normalizedPathname}`
      } catch (error) {
        return ''
      }
    }

    const isLegacyCreativePage = () => {
      if (route.path !== '/Iframe') {
        return false
      }
      const targetUrl = normalizeTargetUrl(route.query.target)
      return targetUrl === LEGACY_CREATIVE_PLATFORM_URL
    }

    const closeCreativePlatformModal = () => {
      showCreativePlatformModal.value = false
    }

    const openCreativePlatform = () => {
      window.open(creativePlatformUrl, '_blank')
      closeCreativePlatformModal()
    }

    watch(
      () => route.fullPath,
      currentPath => {
        if (isLegacyCreativePage()) {
          if (lastPromptRoute.value !== currentPath) {
            showCreativePlatformModal.value = true
            lastPromptRoute.value = currentPath
          }
          return
        }
        showCreativePlatformModal.value = false
        lastPromptRoute.value = ''
      },
      {
        immediate: true
      }
    )

    // 下载后自增下载数量
    window.cupsheIframe.updateExportCount = () => {
      useCount.value.count++
    }
    //  限制网页浏览
    const isWarning = ref(false)
    const closable = ref(false)
    const second = ref(5)
    const limitBrower = () => {
      // if (!isFF && !isChrome && !isSafri) {
      if (detectBrowser() !== 'Google Chrome') {
        // // 24小时内关闭后不显示
        const preTime = +localStorage.getItem('forbid_brower_close')
        const curTime = new Date().getTime()
        const durationTime = 24 * 60 * 60 * 1000
        if (curTime - preTime > durationTime || !preTime) {
          isWarning.value = true
        }
        // 5s后弹窗可关闭
        const interval = setInterval(() => {
          if (second.value === 1) {
            clearInterval(interval)
            closable.value = true
            return
          }
          second.value--
        }, 1000)
      }
    }
    const closeModal = () => {
      isWarning.value = false
      localStorage.setItem('forbid_brower_close', new Date().getTime())
    }
    const closeTag = data => {
      //  详情匹配 tab名含 id
      const routerTags = JSON.parse(
        sessionStorage.getItem(PORTAL_ROUTER_TAG_LIST)
      )
      const index = routerTags.findIndex(
        item => item.menuName === data.menuName
      )
      if (index > -1) {
        store.commit(
          'user/saveHistoryRouter',
          {
            index
          },
          {
            root: true
          }
        )
      }
    }
    /** 每天只上报一次 */
    const trackBrowerInfo = () => {
      const date = moment().format('YYYY-MM-DD')
      const local_track_flag = localStorage.getItem('track_brower_flag')
      let json = {}
      if (local_track_flag) {
        json = JSON.parse(local_track_flag)
      }
      if (!local_track_flag || !json[date]) {
        localStorage.setItem(
          'track_brower_day',
          JSON.stringify({
            [date]: 1
          })
        )
      }
    }
    const handlerUrl = e => {
      // 使用 window.history.replaceState 把参数放在 url 后面，不刷新页面
      const params = JSON.parse(e.data.queryParams)
      console.log(params, 'params')
      if (params) {
        // 获取当前URL和查询参数
        const currentUrl = new URL(window.location.href)
        // 保留原始路径部分，不包含任何查询参数
        const baseUrl = currentUrl.origin + currentUrl.pathname
        // 创建新的参数对象
        let finalParams = new URLSearchParams()
        // 检查当前URL是否有target参数
        const targetParam = currentUrl.searchParams.get('target')
        if (targetParam) {
          // 保留target参数，但不包含其可能携带的参数部分
          const targetUrl = targetParam.split('?')[0] // 只取问号前面的部分
          finalParams.set('target', targetUrl)
        }
        // 添加新参数
        const newParams = new URLSearchParams(params)
        newParams.forEach((value, key) => {
          finalParams.set(key, value)
        })
        // 手动构建查询字符串
        let queryString = '?' // 始终以问号开始查询字符串
        let isFirst = true
        finalParams.forEach((value, key) => {
          if (key === 'target') {
            // target参数需要特殊处理，确保格式正确
            const targetValue = value.toString()
            // 判断target参数值中是否已有问号
            if (targetValue.includes('?')) {
              queryString += `${key}=${targetValue}`
            } else {
              queryString += `${key}=${targetValue}?`
            }
          } else {
            if (!isFirst) {
              queryString += '&'
            }
            // 非target参数的处理
            queryString += `${key}=${value}`
            isFirst = false
          }
        })
        const newUrl = baseUrl + decodeURIComponent(queryString)
        console.log(newUrl, 'newurl')
        window.history.replaceState(null, '', newUrl)
      }
    }
    // 判断浏览器是否为谷歌和火狐
    onMounted(() => {
      window.addEventListener('message', event => {
        let { type } = event.data
        if (type === 'userExperienceSumbit') {
          const data = event.data
          try {
            formModalRef.value.open({
              ...data,
              formItems: JSON.parse(data.apiData.params)
            })
          } catch (e) {
            // todo e
          }
        }
      })
      function handler(e) {
        if (+e.data === 400001) {
          clear()
          router.push({
            path: '/login'
          })
        }
        switch (e.data.type) {
          // 导出数量的计算
          case 'exportNum':
            useCount.value.count++
            break
          case 'open':
            window.currentIframe.classList.add('modalIframe')
            break
          case 'close':
            window.currentIframe.classList.remove('modalIframe')
            break
          case 'breadcrumb':
            store.commit(
              'user/saveHistoryRouter',
              {
                data: e.data
              },
              {
                root: true
              }
            )
            break
          case 'hrefReplace':
            window.history.replaceState(
              null,
              null,
              window.location.href.replace(e.data.key, e.data.value)
            )
            break
          case 'clostTab':
            closeTag(e.data)
            break
          case 'openDownLoadModal':
            store.commit('OPEN_DOWNLOAD_MODAL', true)
            break
          case 'updateParentUrl':
            handlerUrl(e)
            break
          default:
            break
        }
      }
      /** iframe 监听子窗口发送消息 */
      iframeListener(handler)
      limitBrower()
      readRecord()
      window.addEventListener('storage', onLocalStorageChange)
    })

    onUnmounted(() => {
      window.removeEventListener('storage', onLocalStorageChange)
    })

    const noticeDetail = ref({})
    const showNoticeModal = ref(false)
    const showDetail = ref(false)
    const noticeIds = ref([])

    const readRecord = async () => {
      const token = localStorage.getItem('token')
      if (!token) return
      let vuex = {}
      if (localStorage.getItem('vuex')) {
        vuex = JSON.parse(localStorage.getItem('vuex'))
      }
      const {
        success,
        retInfo,
        data
      } = await announcementCenter.read_record_post({
        isPop: 1,
        isRead: 0,
        isMandatory: 1,
        pageNum: 1,
        pageSize: 100,
        responsibleId: vuex?.user?.userInfo?.userId,
        scopeType: 1
      })
      if (success) {
        if (data?.list?.length) {
          noticeDetail.value = data.list[0]
          noticeIds.value = data.list?.map(item => item.id)
          // showNoticeModal.value = true
          showDetail.value = true
        } else {
          // showNoticeModal.value = false
          showDetail.value = false
        }
      } else {
        message.error(retInfo)
      }
    }
    provide('showNoticeModal', showNoticeModal)
    const closeNoticeDetail = () => {
      showDetail.value = false
      noticeIds.value.shift()
      nextTick(() => {
        if (noticeIds.value.length) {
          showDetail.value = true
        }
      })
    }

    return {
      formModalRef,
      isTOB,
      creativePlatformUrl,
      isWarning,
      close,
      closable,
      second,
      closeCreativePlatformModal,
      closeModal,
      openCreativePlatform,
      showCreativePlatformModal,
      showNoticeModal,
      noticeDetail,
      showDetail,
      showOperationPermissionModal,
      closeNoticeDetail,
      noticeIds
    }
  }
}
</script>
<style lang="scss">
#portal-app {
  height: 100%;
}
</style>
<style lang="scss">
.portal-ant-layout-sider.portal-ant-layout-sider-dark.portal-ant-layout-sider-collapsed.portal-ant-layout-sider-has-trigger {
  width: 0px !important;
  min-width: 0px !important;
  max-width: 0px !important;
}
.portal-ant-layout-sider.portal-ant-layout-sider-dark.portal-ant-layout-sider-collapsed.portal-ant-layout-sider-has-trigger
  .portal-ant-layout-sider-children {
  display: none;
}

.portal-ant-layout-sider.portal-ant-layout-sider-dark.portal-ant-layout-sider-collapsed.portal-ant-layout-sider-has-trigger
  .portal-ant-layout-sider-trigger {
  width: 70px !important;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  bottom: 20px;
}

.aside {
  z-index: 1;
}
</style>
